import {CLEAR_BERTDATA}  from '../_CONSTANTS';

export const clearBERTData = () => {
  return {
  type: CLEAR_BERTDATA,
  payload: {}
}
}

